import useTrustedEmailSender, {
  trustedEmailSenderState
} from 'Hooks/useTrustedEmailSender'
import { evalCondition } from 'mailup-react-helpers'
import {
  FormElement,
  InputTextIcon,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  toastShow,
  TrustedEmailInput
} from 'mailup-web-components'
import { senderConfigState } from 'Pages/Task/recoil/state/task'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useSetRecoilState } from 'recoil'

const InputSenderEmail = () => {
  const intl = useIntl()

  const [
    { SenderEmail, IsPecPlus, FetchedSender, CustomSender },
    setSenderConfig
  ] = useRecoilState(senderConfigState)

  const setTrustedEmailState = useSetRecoilState(
    trustedEmailSenderState('trustedSender')
  )

  const handleRegisterSuccess = () => {
    toastShow(
      intl.formatMessage({
        id: 'Load.Common.EmailSendMessage'
      }),
      TOAST_VARIANT_SUCCESS
    )
  }

  const handleRegisterError = () => {
    toastShow(
      intl.formatMessage({
        id: 'Load.Common.LoadingDataError'
      }),
      TOAST_VARIANT_ERROR
    )
  }

  const trustedSenderProps = useTrustedEmailSender(
    'trustedSender',
    SenderEmail,
    SenderEmail,
    handleRegisterSuccess,
    handleRegisterError
  )

  const isWL = evalCondition('co:WHITELABEL')

  useEffect(() => {
    if (!FetchedSender && !IsPecPlus) {
      setTrustedEmailState((prev) => ({
        ...prev,
        value: SenderEmail || undefined
      }))

      setSenderConfig((prev) => ({
        ...prev,
        FetchedSender: true
      }))
    }
  }, [FetchedSender, SenderEmail, IsPecPlus])

  useEffect(() => {
    if (FetchedSender && trustedSenderProps.value !== SenderEmail) {
      setSenderConfig((prev) => ({
        ...prev,
        IsDiry: true,
        SenderEmail: trustedSenderProps.value
      }))
    }
  }, [trustedSenderProps.value])

  useEffect(() => {
    setSenderConfig((prev) => ({
      ...prev,
      sernderEmailValid:
        trustedSenderProps.variant === 'success' ||
        trustedSenderProps.variant === 'neutral' ||
        trustedSenderProps.variant === 'warning' ||
        trustedSenderProps.variant === 'error'
    }))
  }, [trustedSenderProps.variant])

  return (
    <div>
      {IsPecPlus ? (
        <>
          <FormElement
            required
            label={intl.formatMessage({ id: 'Load.Common.SenderEmailLabel' })}
            labelHelp={intl.formatMessage({
              id: 'Load.PecPlus.AltImgMailMittPec'
            })}
          >
            <InputTextIcon
              placeholder={SenderEmail}
              disabled
              data-mu-test='input-SenderEmail'
              tooltip={intl.formatMessage({
                id: isWL
                  ? 'Load.PecPlus.senderPecTooltipWL'
                  : 'Load.PecPlus.senderPecTooltip'
              })}
            />
          </FormElement>
        </>
      ) : (
        <>
          <FormElement
            required
            label={
              CustomSender
                ? intl.formatMessage({
                    id: 'Load.EmailSendingWizard.DefaultSenderEmailLabel'
                  })
                : intl.formatMessage({
                    id: 'Load.Common.SenderEmailLabel'
                  })
            }
            labelHelp={intl.formatMessage({
              id: 'Load.Common.SenderEmailTooltip'
            })}
          >
            <div data-mu-test='sending-wizard-input-sender-email'>
              <TrustedEmailInput
                disabled={evalCondition('uo:EMAILSENDERLOCKED')}
                id='trustedSender'
                {...trustedSenderProps}
              />
            </div>
          </FormElement>
        </>
      )}
    </div>
  )
}

export default InputSenderEmail
